import src from "IMAGE";
export default { src, width: 371, height: 758, blurWidth: 0, blurHeight: 0};
